module.exports = __webpack_public_path__ + "static/media/categoryMasterActive.46377ced.svg";